import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapNavbarResponse } from "src/utils/mapNavbar";

/**
 * View-ready navbar tree from pg-payload-cms (`GET /api/navbar`).
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapNavbar').NavbarLink[]>}
 */
export async function fetchNavbar(locale) {
  const url = buildPayloadApiUrl("/api/navbar", { locale });
  const data = await payloadFetch(url);
  return mapNavbarResponse(data);
}

/**
 * Raw navbar-items docs for Live Preview tree rebuild.
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<Object[]>}
 */
export async function fetchNavbarItems(locale) {
  const url = buildPayloadApiUrl("/api/navbar-items", {
    locale,
    limit: 500,
    depth: 2,
    sort: "_order",
    pagination: false,
  });
  const response = await payloadFetch(url);
  return Array.isArray(response?.docs) ? response.docs : [];
}
